import angular from 'angular';

SavedCartDetailSidebar.$inject = ['cart', '$location'];

export function SavedCartDetailSidebar(cart, $location) {
    const vm = angular.extend(this, {
        cart,
        url: '',
        onTextClick: onTextClick,
        updateUrl: updateUrl,
    });

    vm.url = $location.absUrl();
    function onTextClick($event) {
        $event.target.select();
    }

    function updateUrl() {
        vm.url = $location.absUrl();
    }
}
